import React, { useEffect, useRef } from "react";
import { takeUntil, tap, catchError, combineLatest, of } from "rxjs";
import PropTypes from "prop-types";
import xstream from "state-x-stream";
import { GRID_COLOR } from "../../constants";
import DimenionsDetector from "../DimensionsDetector";

function controller({ props$, destroyed$ }) {
  const { zoomService } = props$.value;
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const pxRatio = 2;
  const bBox = {};

  function resetSize(width) {
    const mainColor = GRID_COLOR;
    canvas.width = pxRatio * width;
    canvas.height = 1;
    canvas.style.width = `${width}px`;
    canvas.style.height = `100%`;
    ctx.scale(pxRatio, pxRatio);

    ctx.strokeStyle = mainColor;
    ctx.fillStyle = mainColor;
    ctx.textAlign = "center";
    ctx.textBaseline = "top";
  }

  function reDraw(scaleTicks = [], scale) {
    if (!scale || !scaleTicks?.length) return;
    const { width } = bBox;

    ctx.clearRect(0, 0, width, 1);
    ctx.beginPath();
    for (let i = 0; i < scaleTicks.length; i++) {
      const d = scaleTicks[i];
      ctx.moveTo(scale(d.g), 0);
      ctx.lineTo(scale(d.g), 1);
    }
    ctx.stroke();
  }

  function updateWidth(width) {
    if (width !== bBox.width) {
      bBox.width = width;
      resetSize(width, bBox.height);
    }
  }

  combineLatest(zoomService.position$, zoomService.xVisScale$)
    .pipe(
      tap(([t, z]) => reDraw(t.scaleTicks, z.scale)),
      takeUntil(destroyed$),
      catchError(() => of(null))
    )
    .subscribe();

  return {
    canvas,
    updateWidth,
  };
}

function VerticalGrid({ canvas, updateWidth }) {
  const axisRef = useRef(null);

  useEffect(() => {
    axisRef.current.innerHTML = "";
    axisRef.current.appendChild(canvas);
  }, [canvas]);

  return (
    <>
      <DimenionsDetector onWidthChange={updateWidth} />
      <div className="tw-absolute tw-inset-0" ref={axisRef} />
    </>
  );
}

VerticalGrid.propTypes = {
  canvas: PropTypes.shape({}).isRequired,
  updateWidth: PropTypes.func.isRequired,
};

export default xstream(controller)(VerticalGrid);
